import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TaxonomyOption, TaxonomyServiceInterface } from '@vendasta/taxonomy';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TaxonomyService implements TaxonomyServiceInterface {
  constructor(private httpClient: HttpClient) {}
  getTaxonomyIds(): Observable<TaxonomyOption[]> {
    return this.httpClient.get<any>('/ajax/v1/taxonomies/').pipe(
      map((res) => res.data),
      map((flatCategories) => {
        return flatCategories.map((category) => this.buildOption(category, flatCategories));
      }),
    );
  }

  buildOption(category: any, flatCategories: any[]): TaxonomyOption {
    const fullNameParts = [];
    const idParts = category.id.split(':');
    if (idParts.length > 1) {
      // Work through all the sub-ids (ie. recreation:diving:deepsea would get recreation and recreation:diving)
      for (let i = 0; i < idParts.length - 1; i++) {
        const partOpt = flatCategories.find((opt) => opt.id === idParts.slice(0, i + 1).join(':'));
        fullNameParts.push(partOpt.name);
      }
    }
    fullNameParts.push(category.name);
    const fullName = fullNameParts.join(' > ');
    return {
      name: fullName,
      fullName: fullName,
      id: category.id,
    };
  }
}
